import { IQnaMaterial, TSearchQnaQuery } from '../interfaces/qna';

import { ProxyClient } from './client/ProxyClient';

export const searchQna = async (params: TSearchQnaQuery) => {
  const { data } = await ProxyClient.get<IQnaMaterial[]>('/qna/search', { params });
  return data;
};
